import React, { useEffect, useMemo, useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { movieBookingApi } from '../../services/movieBookingApi';
import './MovieBooking.css';

const getLocalDateString = () => {
  const now = new Date();
  const offsetMs = now.getTimezoneOffset() * 60 * 1000;
  return new Date(now.getTime() - offsetMs).toISOString().slice(0, 10);
};

const Showtimes = () => {
  const { movieId } = useParams();
  const [searchParams] = useSearchParams();
  const [showtimes, setShowtimes] = useState(null);
  const [movie, setMovie] = useState(null);
  const [loading, setLoading] = useState(true);

  const city = searchParams.get('city') || 'Bangalore';
  const date = searchParams.get('date') || getLocalDateString();

  useEffect(() => {
    const loadShowtimes = async () => {
      try {
        const [movieResponse, showtimeResponse] = await Promise.all([
          movieBookingApi.getMovieById(movieId),
          movieBookingApi.getShowTimes(movieId, city, date),
        ]);
        setMovie(movieResponse.data);
        setShowtimes(showtimeResponse.data);
      } catch (error) {
        setShowtimes(null);
      } finally {
        setLoading(false);
      }
    };
    loadShowtimes();
  }, [movieId, city, date]);

  const theatres = useMemo(() => showtimes?.theatres || [], [showtimes]);

  return (
    <div className="movie-booking-page">
      <div className="movie-booking-header">
        <div>
          <h1 className="movie-booking-title">Showtimes</h1>
          <p className="movie-booking-note">
            {movie?.title || 'Movie'} • {city} • {date}
          </p>
        </div>
        <Link to="/movies" className="movie-booking-button secondary">Back</Link>
      </div>

      {loading && <p>Loading showtimes...</p>}
      {!loading && !theatres.length && <p>No shows found for this date.</p>}

      <div className="movie-booking-card-grid">
        {theatres.map((theatre) => (
          <div key={theatre.theatreId} className="movie-booking-card">
            <h3>{theatre.theatreName}</h3>
            <p className="movie-booking-note">Select a time to view seats.</p>
            <div className="movie-booking-actions">
              {(theatre.showTimes || []).map((slot) => (
                <Link
                  key={slot.showId}
                  to={`/movies/${movieId}/shows/${slot.showId}/seats?city=${encodeURIComponent(city)}&date=${encodeURIComponent(date)}&theatreId=${encodeURIComponent(theatre.theatreId)}`}
                  className="movie-booking-button secondary"
                >
                  {slot.startTime}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Showtimes;
